import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "container mx-auto pt-8 pb-16 px-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "text-gray-100 text-3xl font-semibold pt-2" }, "Reports", -1)
const _hoisted_3 = { class: "bg-white text-gray-700 p-4 mt-8 rounded-md shadow-md" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "mb-4 flex justify-between flex-col sm:flex-row" }
const _hoisted_7 = { class: "flex rounded-md mb-2 sm:mb-0" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "inline-flex items-center px-3 rounded-l-md border border-r-0 border-gray-200 bg-gray-50 text-gray-500 text-sm" }, " Month ", -1)
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "flex justify-between items-stretch" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", null, "Import", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", null, "Export", -1)
const _hoisted_13 = { class: "flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", {
  class: "hidden sm:inline-block sm:align-middle sm:h-screen",
  "aria-hidden": "true"
}, "​", -1)
const _hoisted_15 = { class: "inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle max-w-lg sm:max-w-full sm:mx-4" }
const _hoisted_16 = { class: "bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4" }
const _hoisted_17 = { class: "flex justify-between flex-col md:flex-row" }
const _hoisted_18 = { class: "mb-2" }
const _hoisted_19 = { class: "inline-block mt-4 w-auto text-sm font-semibold py-1 px-2 uppercase rounded-md text-indigo-600 bg-indigo-100" }
const _hoisted_20 = {
  title: "Contract Type",
  class: "inline-block ml-2 mt-4 w-auto text-sm font-semibold py-1 px-2 uppercase rounded-md text-indigo-600 bg-indigo-100"
}
const _hoisted_21 = {
  title: "Measure Unit",
  class: "inline-block ml-2 mt-4 w-auto text-sm font-semibold py-1 px-2 uppercase rounded-md text-indigo-600 bg-indigo-100"
}
const _hoisted_22 = {
  key: 0,
  class: "flex justify-between items-stretch mt-4 md:mt-0 mb-auto"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", null, "Import", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", null, "Export", -1)
const _hoisted_25 = { class: "bg-gray-50 px-4 py-3 sm:px-6 sm:flex flex-row-reverse" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", null, "Save", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", null, "Close", -1)
const _hoisted_28 = { class: "flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("span", {
  class: "hidden sm:inline-block sm:align-middle sm:h-screen",
  "aria-hidden": "true"
}, "​", -1)
const _hoisted_30 = { class: "inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle w-11/12 max-w-lg sm:mx-4" }
const _hoisted_31 = { class: "bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "mb-2" }, "Import CSV Report", -1)
const _hoisted_33 = { class: "inline-block mt-4 w-auto text-sm font-semibold py-1 px-2 uppercase rounded-md text-indigo-600 bg-indigo-100" }
const _hoisted_34 = { class: "m-auto" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("span", null, "Select or drop .csv file", -1)
const _hoisted_36 = {
  key: 0,
  class: "mt-4 w-auto text-sm font-semibold"
}
const _hoisted_37 = /*#__PURE__*/_createElementVNode("span", { class: "py-1 px-2 rounded-l-md text-gray-600 bg-gray-100 border border-gray-200 border-r-0" }, "Selected file:", -1)
const _hoisted_38 = { class: "py-1 px-2 rounded-r-md text-indigo-600 bg-indigo-100 border border-indigo-200" }
const _hoisted_39 = { class: "bg-gray-50 px-4 py-3 sm:px-6 sm:flex flex-row-reverse" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("span", null, "Import", -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("span", null, "Close", -1)
const _hoisted_42 = { class: "flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("span", {
  class: "hidden sm:inline-block sm:align-middle sm:h-screen",
  "aria-hidden": "true"
}, "​", -1)
const _hoisted_44 = { class: "inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle w-11/12 max-w-lg sm:mx-4" }
const _hoisted_45 = { class: "bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("div", { class: "mb-2" }, "Import Multiple Contracts", -1)
const _hoisted_47 = { class: "inline-block mt-4 w-auto text-sm font-semibold py-1 px-2 uppercase rounded-md text-indigo-600 bg-indigo-100" }
const _hoisted_48 = { class: "m-auto" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("span", null, "Select or drop .csv file", -1)
const _hoisted_50 = {
  key: 0,
  class: "mt-4 w-auto text-sm font-semibold"
}
const _hoisted_51 = /*#__PURE__*/_createElementVNode("span", { class: "py-1 px-2 rounded-l-md text-gray-600 bg-gray-100 border border-gray-200 border-r-0" }, "Selected file:", -1)
const _hoisted_52 = { class: "py-1 px-2 rounded-r-md text-indigo-600 bg-indigo-100 border border-indigo-200" }
const _hoisted_53 = { class: "bg-gray-50 px-4 py-3 sm:px-6 sm:flex flex-row-reverse" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("span", null, "Continue", -1)
const _hoisted_55 = /*#__PURE__*/_createElementVNode("span", null, "Close", -1)
const _hoisted_56 = { class: "flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("span", {
  class: "hidden sm:inline-block sm:align-middle sm:h-screen",
  "aria-hidden": "true"
}, "​", -1)
const _hoisted_58 = { class: "inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle w-11/12 max-w-lg sm:mx-4" }
const _hoisted_59 = { class: "bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("div", { class: "mb-2" }, "Verify contracts to import", -1)
const _hoisted_61 = { class: "inline-block mt-4 w-auto text-sm font-semibold py-1 px-2 uppercase rounded-md text-indigo-600 bg-indigo-100" }
const _hoisted_62 = { class: "mb-4" }
const _hoisted_63 = { class: "mb-4" }
const _hoisted_64 = { class: "list-disc list-inside" }
const _hoisted_65 = { class: "inline-block w-auto ml-1 text-xs font-semibold py-1 px-1 uppercase rounded-md text-indigo-600 bg-indigo-100" }
const _hoisted_66 = { class: "bg-gray-50 px-4 py-3 sm:px-6 sm:flex flex-row-reverse" }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("span", null, "Confirm", -1)
const _hoisted_68 = /*#__PURE__*/_createElementVNode("span", null, "Close", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UploadIcon = _resolveComponent("UploadIcon")!
  const _component_app_button = _resolveComponent("app-button")!
  const _component_TruckIcon = _resolveComponent("TruckIcon")!
  const _component_contract_table = _resolveComponent("contract-table")!
  const _component_DialogOverlay = _resolveComponent("DialogOverlay")!
  const _component_TransitionChild = _resolveComponent("TransitionChild")!
  const _component_DialogTitle = _resolveComponent("DialogTitle")!
  const _component_report_table = _resolveComponent("report-table")!
  const _component_CheckIcon = _resolveComponent("CheckIcon")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_TransitionRoot = _resolveComponent("TransitionRoot")!
  const _component_PlusIcon = _resolveComponent("PlusIcon")!
  const _component_file_upload = _resolveComponent("file-upload")!
  const _component_RefreshIcon = _resolveComponent("RefreshIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, " Loading. "))
        : (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedMonth) = $event)),
                  class: "form-select appearance-none block w-full md:w-auto text-sm font-normal text-gray-700 bg-white bg-clip-padding bg-no-repeat border border-solid border-gray-200 rounded-r-md"
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.months, (month) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: month.key,
                      value: month
                    }, _toDisplayString(month.name), 9, _hoisted_9))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.selectedMonth]
                ])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_app_button, {
                  onClick: _ctx.openMultipleContractsImportModal,
                  type: "blue",
                  class: "mr-1 flex-1"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_UploadIcon, { class: "h-5 w-5 mr-2 -ml-1" }),
                    _hoisted_11
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_app_button, {
                  onClick: _ctx.exportToCsv,
                  type: "blue",
                  class: "ml-1 flex-1"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_TruckIcon, { class: "h-5 w-5 mr-2 -ml-1" }),
                    _hoisted_12
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ]),
            (_openBlock(), _createBlock(_component_contract_table, {
              month: _ctx.selectedMonth,
              showMeasureUnit: true,
              key: _ctx.selectedMonth.key + _ctx.modalRefreshKey,
              onOpenMonthModal: _ctx.openContractMonthModal,
              onOpenDateModal: _ctx.openContractDateModal
            }, null, 8, ["month", "onOpenMonthModal", "onOpenDateModal"]))
          ]))
    ]),
    _createVNode(_component_TransitionRoot, {
      as: "template",
      show: _ctx.reportModalIsOpen
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Dialog, {
          as: "div",
          class: "fixed z-10 inset-0 overflow-y-auto",
          onClose: _ctx.closeReportModal
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_TransitionChild, {
                as: "template",
                enter: "ease-out duration-300",
                "enter-from": "opacity-0",
                "enter-to": "opacity-100",
                leave: "ease-in duration-200",
                "leave-from": "opacity-100",
                "leave-to": "opacity-0"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_DialogOverlay, { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" })
                ]),
                _: 1
              }),
              _hoisted_14,
              _createVNode(_component_TransitionChild, {
                as: "template",
                enter: "ease-out duration-300",
                "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                leave: "ease-in duration-200",
                "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _createVNode(_component_DialogTitle, {
                        as: "h2",
                        class: "text-3xl leading-6 font-semibold text-gray-800 mb-4 tracking-wide"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_17, [
                            _createElementVNode("div", null, [
                              _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.modalSettings.contract.person.surname) + " " + _toDisplayString(_ctx.modalSettings.contract.person.name), 1),
                              _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.modalSettings.period), 1),
                              _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.modalSettings.contract.contractType.id), 1),
                              _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.modalSettings.contract.measureUnit.id) + _toDisplayString(_ctx.modalSettings.contract.measureUnitLabel ? `: ${_ctx.modalSettings.contract.measureUnitLabel}` : ''), 1)
                            ]),
                            (_ctx.modalSettings.type == 'month')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                  _createVNode(_component_app_button, {
                                    onClick: _ctx.openImportModal,
                                    type: "blue",
                                    class: "mr-1 flex-1"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_UploadIcon, { class: "h-5 w-5 mr-2 -ml-1" }),
                                      _hoisted_23
                                    ]),
                                    _: 1
                                  }, 8, ["onClick"]),
                                  _createVNode(_component_app_button, {
                                    onClick: _ctx.exportContractToCsv,
                                    type: "blue",
                                    class: "ml-1 flex-1"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_TruckIcon, { class: "h-5 w-5 mr-2 -ml-1" }),
                                      _hoisted_24
                                    ]),
                                    _: 1
                                  }, 8, ["onClick"])
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _: 1
                      }),
                      (_ctx.selectedMonth && _ctx.modalSettings)
                        ? (_openBlock(), _createBlock(_component_report_table, {
                            ref: "reportTable",
                            key: _ctx.modalSettings.contract.id + '-' + _ctx.selectedMonth.key + '-' + _ctx.reportTableRefreshKey,
                            dataMode: _ctx.modalSettings.type,
                            month: _ctx.modalSettings.selectedMonth,
                            date: _ctx.modalSettings.selectedDate,
                            contract: _ctx.modalSettings.contract
                          }, null, 8, ["dataMode", "month", "date", "contract"]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_25, [
                      _createVNode(_component_app_button, {
                        onClick: _ctx.submitModal,
                        type: "blue",
                        class: _normalizeClass(['mb-2 sm:mb-0 w-full sm:w-auto'])
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_CheckIcon, { class: "h-5 w-5 mr-2 -ml-1" }),
                          _hoisted_26
                        ]),
                        _: 1
                      }, 8, ["onClick"]),
                      _createVNode(_component_app_button, {
                        onClick: _ctx.closeReportModal,
                        type: "gray",
                        class: _normalizeClass(['mr-2 w-full sm:w-auto'])
                      }, {
                        default: _withCtx(() => [
                          _hoisted_27
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ])
                  ])
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["onClose"])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_TransitionRoot, {
      as: "template",
      show: _ctx.csvModalIsOpen
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Dialog, {
          as: "div",
          class: "fixed z-10 inset-0 overflow-y-auto",
          onClose: _ctx.closeImportModal
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_28, [
              _createVNode(_component_TransitionChild, {
                as: "template",
                enter: "ease-out duration-300",
                "enter-from": "opacity-0",
                "enter-to": "opacity-100",
                leave: "ease-in duration-200",
                "leave-from": "opacity-100",
                "leave-to": "opacity-0"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_DialogOverlay, { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" })
                ]),
                _: 1
              }),
              _hoisted_29,
              _createVNode(_component_TransitionChild, {
                as: "template",
                enter: "ease-out duration-300",
                "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                leave: "ease-in duration-200",
                "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("div", _hoisted_31, [
                      _createVNode(_component_DialogTitle, {
                        as: "h2",
                        class: "text-3xl leading-6 font-semibold text-gray-800 mb-4 tracking-wide"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_32,
                          _createElementVNode("div", _hoisted_33, _toDisplayString(this.selectedMonth.name), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_file_upload, {
                        onInputFile: _ctx.onInputFile,
                        drop: true,
                        extensions: "csv",
                        multiple: false,
                        class: "w-full m-auto py-8 bg-gray-50 rounded-md border border-gray-100"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_34, [
                            _createVNode(_component_app_button, {
                              onClick: _ctx.importContractCsvFile,
                              type: "green"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_PlusIcon, { class: "h-5 w-5 mr-2 -ml-1" }),
                                _hoisted_35
                              ]),
                              _: 1
                            }, 8, ["onClick"])
                          ]),
                          (_ctx.csvImportFile)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                                _hoisted_37,
                                _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.csvImportFile.name), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["onInputFile"])
                    ]),
                    _createElementVNode("div", _hoisted_39, [
                      _createVNode(_component_app_button, {
                        onClick: _ctx.importContractCsvFile,
                        type: "blue",
                        class: _normalizeClass(['mb-2 sm:mb-0 w-full sm:w-auto'])
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_UploadIcon, { class: "h-5 w-5 mr-2 -ml-1" }),
                          _hoisted_40
                        ]),
                        _: 1
                      }, 8, ["onClick"]),
                      _createVNode(_component_app_button, {
                        onClick: _ctx.closeImportModal,
                        type: "gray",
                        class: _normalizeClass(['mr-2 w-full sm:w-auto'])
                      }, {
                        default: _withCtx(() => [
                          _hoisted_41
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ])
                  ])
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["onClose"])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_TransitionRoot, {
      as: "template",
      show: _ctx.multipleContractsCsvModalIsOpen
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Dialog, {
          as: "div",
          class: "fixed z-10 inset-0 overflow-y-auto",
          onClose: _ctx.closeMultipleContractsImportModal
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_42, [
              _createVNode(_component_TransitionChild, {
                as: "template",
                enter: "ease-out duration-300",
                "enter-from": "opacity-0",
                "enter-to": "opacity-100",
                leave: "ease-in duration-200",
                "leave-from": "opacity-100",
                "leave-to": "opacity-0"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_DialogOverlay, { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" })
                ]),
                _: 1
              }),
              _hoisted_43,
              _createVNode(_component_TransitionChild, {
                as: "template",
                enter: "ease-out duration-300",
                "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                leave: "ease-in duration-200",
                "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_44, [
                    _createElementVNode("div", _hoisted_45, [
                      _createVNode(_component_DialogTitle, {
                        as: "h2",
                        class: "text-3xl leading-6 font-semibold text-gray-800 mb-4 tracking-wide"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_46,
                          _createElementVNode("div", _hoisted_47, _toDisplayString(this.selectedMonth.name), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_file_upload, {
                        onInputFile: _ctx.onInputFile,
                        drop: true,
                        extensions: "csv",
                        multiple: false,
                        class: "w-full m-auto py-8 bg-gray-50 rounded-md border border-gray-100"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_48, [
                            _createVNode(_component_app_button, {
                              onClick: _ctx.importContractCsvFile,
                              type: "green"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_PlusIcon, { class: "h-5 w-5 mr-2 -ml-1" }),
                                _hoisted_49
                              ]),
                              _: 1
                            }, 8, ["onClick"])
                          ]),
                          (_ctx.csvImportFile)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                                _hoisted_51,
                                _createElementVNode("span", _hoisted_52, _toDisplayString(_ctx.csvImportFile.name), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["onInputFile"])
                    ]),
                    _createElementVNode("div", _hoisted_53, [
                      _createVNode(_component_app_button, {
                        onClick: _ctx.prepareMultipleContractsFromCsv,
                        type: _ctx.importInProgress ? 'blue-disabled' : 'blue',
                        class: _normalizeClass(['mb-2 sm:mb-0 w-full sm:w-auto'])
                      }, {
                        default: _withCtx(() => [
                          (_ctx.importInProgress)
                            ? (_openBlock(), _createBlock(_component_RefreshIcon, {
                                key: 0,
                                class: "h-5 w-5 mr-2 -ml-1 animate-spin"
                              }))
                            : (_openBlock(), _createBlock(_component_UploadIcon, {
                                key: 1,
                                class: "h-5 w-5 mr-2 -ml-1"
                              })),
                          _hoisted_54
                        ]),
                        _: 1
                      }, 8, ["onClick", "type"]),
                      _createVNode(_component_app_button, {
                        onClick: _ctx.closeMultipleContractsImportModal,
                        type: "gray",
                        class: _normalizeClass(['mr-2 w-full sm:w-auto'])
                      }, {
                        default: _withCtx(() => [
                          _hoisted_55
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ])
                  ])
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["onClose"])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_TransitionRoot, {
      as: "template",
      show: _ctx.verifyContratsModalIsOpen
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Dialog, {
          as: "div",
          class: "fixed z-10 inset-0 overflow-y-auto",
          onClose: _ctx.closeVerifyContratsModal
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_56, [
              _createVNode(_component_TransitionChild, {
                as: "template",
                enter: "ease-out duration-300",
                "enter-from": "opacity-0",
                "enter-to": "opacity-100",
                leave: "ease-in duration-200",
                "leave-from": "opacity-100",
                "leave-to": "opacity-0"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_DialogOverlay, { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" })
                ]),
                _: 1
              }),
              _hoisted_57,
              _createVNode(_component_TransitionChild, {
                as: "template",
                enter: "ease-out duration-300",
                "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                leave: "ease-in duration-200",
                "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_58, [
                    _createElementVNode("div", _hoisted_59, [
                      _createVNode(_component_DialogTitle, {
                        as: "h2",
                        class: "text-3xl leading-6 font-semibold text-gray-800 mb-4 tracking-wide"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_60,
                          _createElementVNode("div", _hoisted_61, _toDisplayString(this.selectedMonth.name), 1)
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", _hoisted_62, [
                        _createElementVNode("p", _hoisted_63, "The following contract reports will be replaced by the data provided in the CSV file for the selected month (" + _toDisplayString(this.selectedMonth.name) + "):", 1),
                        _createElementVNode("ul", _hoisted_64, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.affectedContracts, (contract) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: contract.id,
                              class: "mb-2 text-sm"
                            }, [
                              _createTextVNode(_toDisplayString(contract.id) + " - " + _toDisplayString(contract.person.surname) + " " + _toDisplayString(contract.person.name) + " ", 1),
                              _createElementVNode("div", _hoisted_65, _toDisplayString(contract.measureUnit.id), 1)
                            ]))
                          }), 128))
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_66, [
                      _createVNode(_component_app_button, {
                        onClick: _ctx.importMultipleContractsFromCsv,
                        type: _ctx.importInProgress ? 'blue-disabled' : 'blue',
                        class: _normalizeClass(['mb-2 sm:mb-0 w-full sm:w-auto'])
                      }, {
                        default: _withCtx(() => [
                          (_ctx.importInProgress)
                            ? (_openBlock(), _createBlock(_component_RefreshIcon, {
                                key: 0,
                                class: "h-5 w-5 mr-2 -ml-1 animate-spin"
                              }))
                            : (_openBlock(), _createBlock(_component_UploadIcon, {
                                key: 1,
                                class: "h-5 w-5 mr-2 -ml-1"
                              })),
                          _hoisted_67
                        ]),
                        _: 1
                      }, 8, ["onClick", "type"]),
                      _createVNode(_component_app_button, {
                        onClick: _ctx.closeVerifyContratsModal,
                        type: "gray",
                        class: _normalizeClass(['mr-2 w-full sm:w-auto'])
                      }, {
                        default: _withCtx(() => [
                          _hoisted_68
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ])
                  ])
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["onClose"])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}